<template>
    <div class="bg-b">
        <div class="nor-h2">
            <div class="container">
                <h2 class="pt-sans-bol ">DEBERES Y DERECHOS DEL SISTEMA
                    DE FORMACIÓN DOCENTE CONTINUA E
                    INVESTIGACIÓN DE TUCUMÁN.</h2>
            </div>

        </div>

        <div class="container">


            <el-card shadow="always" class="card-norma" :body-style="{ padding: '20px' }">
                <el-row :gutter="20">

                    <el-col :sm="6" :offset="0" v-if="!$isMobile()">
                        <ul class="menu-norma">
                            <li v-for="m in norma" :class="selectId == 'norma' + m.id ? 'norma-act-menu' : ''"
                                :key="m.id" @click="mover('norma' +m.id)">{{ m.titulo }}</li>

                            <li class="efp" @click="$router.push({name:'docentes'})">
                                <strong> Espacio de Formación Personal</strong>

                            </li>
                            <li class="ofertas" @click="$router.push('/')">
                                <strong>Ofertas de <br> capacitaciones</strong>

                            </li>
                        </ul>

                    </el-col>
                    <el-col :sm="18" :offset="0">
                        <div class="content-norma parent1" id="content-norma">
                            <div v-for=" t in norma" :key="t.id" class="text-norma" :id="'norma'+t.id">
                                <h2 :class="selectId == 'norma' + t.id ? 'norma-act-menu' : ''" v-html="t.titulo"></h2>
                                <div v-if="t.texto" v-html="t.texto"></div>
                                <div v-if="!t.texto">
                                    <ul>
                                        <li v-for="c in t.clausulas" :key="c.numero">
                                            <strong>{{ c.numero }}:</strong> <span v-html="c.texto"></span>
                                        </li>
                                    </ul>
                                </div>

                            </div>


                        </div>

                    </el-col>
                </el-row>
            </el-card>


        </div>
    </div>
</template>

<script>
 import normativa from "@/assets/json/normativas.json"
var VueScrollTo = require('vue-scrollto');
var options = {
    container: '#content-norma',
    easing: 'ease-in',
    lazy: true,
    offset: -60,
    force: true,
    cancelable: true,
    onStart: function (element) {
        // scrolling started
    },
    onDone: function (element) {
        // scrolling is done
    },
    onCancel: function () {
        // scrolling has been interrupted
    },
    x: false,
    y: true
}

    export default {
        data() {
            return {
                norma: normativa,
                menu: [],
                selectId: 'norma1'
            }
        },
        methods: {
            mover(norma) {
                this.selectId = norma
                VueScrollTo.scrollTo('#' + norma, 500, options)
               
            }
        },
    }
</script>

<style>
.efp strong{
    display: block;
    /* margin-top: 15px; */
}
.efp{
    text-transform:uppercase; 
    background:#174263 url(@/assets/base2.png) !important; 
    /* height:60px; */
    /* text-align: center; */
    
    /* background-size: 200% 200%  */
}

.ofertas strong {
    display: block;
    /* margin-top: 15px; */
}

.ofertas {
    text-transform: uppercase;
    background: #800322ce url(@/assets/base2.png) !important;
    /* height: 60px; */
    /* text-align: center; */

    /* background-size: 200% 200%  */
}
.text-norma ol,.text-norma ul {
    
    margin-left: 30px;
}

.text-norma ol > li {

    padding-bottom: 2px;
}
.text-norma ul>li {

    padding-bottom: 10px;
}
.text-norma{
    padding: 0px 20px;
}
.text-norma div{
margin: 10px 0px;
padding: 10px;
}
.text-norma h2 {
    margin-bottom: 10px;
    font-family: "PT Sans", sans-serif;
}
@media screen and (max-width: 992px) {

   
       .nor-h2{
        font-size:18px;
       }
        .text-norma ol,
        .text-norma ul {
    
            margin-left: 30px;
        }
    
        .text-norma ol>li {
    
            padding-bottom: 2px;
        }
    
        .text-norma ul>li {
    
            padding-bottom: 10px;
        }
    
        .text-norma {
            padding: 0px 0px;
        }
    
      
}
</style>
<style lang="scss" scoped>
.card-norma {
    margin-top: 20px;

}

.content-norma {
    height: calc(100vh - 280px);
    overflow-y: scroll;
    overflow-x: hidden;
}


.menu-norma {
    list-style: none;
    // font-family: "PT Sans", sans-serif;
    font-weight: 500;
    margin: 0;
    padding: 0;


}

.menu-norma li {
    cursor: pointer;
    background: #29abe2;
    margin-bottom: 10px;
    color: white;
    padding: 10px;
    font-size: 14px;
    border-radius: 2px;
    transition: all 0.2s;
}



.norma-act-menu {
    background: #092e4d !important;
    color: #ffffff;
    padding: 10px;
}
@media screen and (max-width: 992px) {
    .card-norma {
            margin-top: 0px;
    
        }
    
        .content-norma {
            height: calc(100vh - 80px);
            overflow-y: scroll;
            overflow-x: hidden;
        }
    
    
        
    
       
    
    
    
        
}
</style>